import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID);

const Contact = () => {
  const form = useRef();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle");

  const sendEmail = (e) => {
    e.preventDefault();
    const el = e.target;
    el.style.pointerEvents = "none";
    el.style.opacity = "0.5";

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(() => {
        el.reset();
        el.style.pointerEvents = "";
        el.style.opacity = "1";
        setStatus("ok");
        setMessage("Sent. I’ll read it soon.");
        setTimeout(() => {
          setStatus("idle");
          setMessage("");
        }, 5000);
      })
      .catch(() => {
        el.style.pointerEvents = "";
        el.style.opacity = "1";
        setStatus("err");
        setMessage("Something went wrong. Try email directly.");
        setTimeout(() => {
          setStatus("idle");
          setMessage("");
        }, 5000);
      });
  };

  const feedbackClass =
    status === "ok"
      ? "contact__feedback contact__feedback--ok"
      : status === "err"
        ? "contact__feedback contact__feedback--err"
        : "contact__feedback";

  return (
    <section id="contact" className="contact" data-aos="fade-up">
      <div className="contact__inner">
        <h2 className="contact__title">Correspondence</h2>
        <p className="contact__subtitle">
          Write like you’re asking a busy engineer for a favor—context, links,
          timeline. I read everything.
        </p>
        <div className="contact__form-wrap">
          <p className="contact__form-title">Project note</p>
          <form ref={form} onSubmit={sendEmail}>
            <label className="visually-hidden" htmlFor="pf-name">
              Name
            </label>
            <input
              id="pf-name"
              className="contact__field"
              type="text"
              name="name"
              placeholder="Name"
              required
              autoComplete="name"
            />
            <label className="visually-hidden" htmlFor="pf-email">
              Email
            </label>
            <input
              id="pf-email"
              className="contact__field"
              type="email"
              name="email"
              placeholder="Email"
              required
              autoComplete="email"
            />
            <label className="visually-hidden" htmlFor="pf-message">
              Message
            </label>
            <textarea
              id="pf-message"
              className="contact__field contact__textarea"
              name="message"
              placeholder="What are you building, and why now?"
              rows={5}
              required
            />
            <p className={feedbackClass} role="status">
              {message}
            </p>
            <button className="contact__submit" type="submit">
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
